export enum DialogEventStatusAction {
  MoveToMonitoring = 'MOVE_TO_MONITORING',
  MoveToInvestigation = 'MOVE_TO_INVESTIGATION',
  ReturnToNew = 'RETURN_TO_NEW',
  StartInvestigation = 'START_INVESTIGATION',
  ReturnToMonitoring = 'RETURN_TO_MONITORING',
  ResolveAsLeak = 'RESOLVE_AS_LEAK',
  ResolveAsCustomerSideLeak = 'RESOLVE_AS_CUSTOMER_SIDE_LEAK',
  ResolveAsNoLeak = 'RESOLVE_AS_NO_LEAK',
  ReopenInvestigation = 'REOPEN_INVESTIGATION',
}

export enum DialogEventStatusActionGroup {
  Resolve = 'RESOLVE',
}

export enum DialogEventCommentRequirement {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export enum DialogEventStatusActionForm {
  None = 'NONE',
  Assignee = 'ASSIGNEE',
  Resolution = 'RESOLUTION',
}
